<div class="paginator">
  <button
    class="paginator-first-page-button"
    [ngClass]="{
      'paginator-first-page-button-disabled':
        currentPage === 1 || totalPages === 0
    }"
    [disabled]="currentPage === 1 || totalPages === 0"
    (click)="goToFirstPage()"
  >
    <i class="bi bi-chevron-bar-left"></i>
  </button>
  <button
    class="paginator-previous-page-button"
    [ngClass]="{
      'paginator-previous-page-button-disabled':
        currentPage === 1 || totalPages === 0
    }"
    [disabled]="currentPage === 1 || totalPages === 0"
    (click)="goToPreviousPage()"
  >
    <i class="bi bi-chevron-left"></i>
  </button>
  <button
    class="paginator-page-button"
    [ngClass]="{ 'paginator-page-button-active': page === currentPage }"
    *ngFor="let page of pagesToShow"
    (click)="goToPage(page)"
  >
    {{ page }}
  </button>
  <button
    class="paginator-next-page-button"
    [ngClass]="{
      'paginator-next-page-button-disabled':
        currentPage === totalPages || totalPages === 0
    }"
    [disabled]="currentPage === totalPages || totalPages === 0"
    (click)="goToNextPage()"
  >
    <i class="bi bi-chevron-right"></i>
  </button>
  <button
    class="paginator-last-page-button"
    [ngClass]="{
      'paginator-last-page-button-disabled':
        currentPage === totalPages || totalPages === 0
    }"
    [disabled]="currentPage === totalPages || totalPages === 0"
    (click)="goToLastPage()"
  >
    <i class="bi bi-chevron-bar-right"></i>
  </button>
</div>
